let multiLang = {
    hk: {
        required: '此項為必填',
		phoneErr: '請正確填寫手機號碼',
		emailErr: '郵箱格式不正確',
        more: '更多'
    },
    cn: {
        required: '此项为必填',
		phoneErr: '请正确填写手机号码',
		emailErr: '邮箱格式不正确',
        more: '更多'
    },
    th: {
        required: 'เป็นข้อมูลที่ต้องกรอก',
		phoneErr: '请正确填写手机号码',
		emailErr: 'รูปแบบอีเมลไม่ถูกต้อง',
        more: 'มากกว่า'
    },
    vn: {
        required: 'Đây là trường bắt buộc',
		phoneErr: '请正确填写手机号码',
		emailErr: 'Định dạng email không chính xác',
        more: 'Hơn'
    },
    jp: {
        required: '必須',
		phoneErr: '请正确填写手机号码',
		emailErr: '電子メールの形式が正しくありません',
        more: 'もっと'
    },
    kr: {
        required: '이 항목은 필수 입력 사항입니다',
		phoneErr: '请正确填写手机号码',
		emailErr: '이메일 형식이 올바르지 않습니다.',
        more: '더'
    },
    en: {
        required: 'This is a required field',
		phoneErr: 'Please enter valid phone numbers',
		emailErr: 'E-mail format is incorrect',
        more: "More"
    }
}

export default function Language() {

    const langCode = document.documentElement.getAttribute('lang');

    let lang;

    if (langCode == "zh-HK" || langCode == "zh-TW") {
        lang = multiLang['hk'];
    } else if (langCode == "sg" || langCode == "au") {
        lang = multiLang['en'];
    } else if (langCode == "ko-KR") {
        lang = multiLang['kr'];
    } else {
        lang = multiLang[langCode]
    }
    
    return lang;
    
}